import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const SpeechStreamRouteGuard = () => {
  const location = useLocation();
  const wasOnQuizRoute = useRef(location.pathname.startsWith('/quiz'));

  useEffect(() => {
    const isQuizRoute = location.pathname.startsWith('/quiz');

    // If navigating away from quiz page, and speechstream is present
    if (wasOnQuizRoute.current && !isQuizRoute) {
      const speechstream = window?.speechstream;
      if (
        speechstream &&
        typeof speechstream?.isToolbarActive === 'function' &&
        typeof speechstream?.toggleBar === 'function'
      ) {
        speechstream.isToolbarActive() && speechstream.toggleBar(false);
      }
    }

    wasOnQuizRoute.current = isQuizRoute;
  }, [location.pathname]);

  return null;
};

export default SpeechStreamRouteGuard;
